import { FC } from 'react';
import { AddCourseItem } from './AddCourseItem';
import { EmptyState } from '@new/common/ui/EmptyState/EmptyState';
import { Course } from '@teachur/http-client';

interface AddCourseListProps {
  courses: Course[];
  addedCourseIds: Set<number>;
  onAdd: (courseId: number) => void;
}

export const AddCourseList: FC<AddCourseListProps> = ({ courses, addedCourseIds, onAdd }) => {
  if (courses.length === 0) {
    return <EmptyState message="No courses available to add." />;
  }

  return (
    <div className="flex flex-col gap-3 max-h-102 overflow-y-auto [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
      {courses.map((course) => (
        <AddCourseItem
          key={course.id}
          course={course}
          isAdded={addedCourseIds.has(course.id)}
          onAdd={onAdd}
        />
      ))}
    </div>
  );
};
